/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { UiService } from '@services/ui/ui.service';
import { Injectable } from '@angular/core';
import { Device, DeviceInfo } from '@capacitor/device';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  /** cache per device info */
  private deviceInfo: DeviceInfo;

  /** cache per device id */
  private deviceId: string;

  constructor(private uiService: UiService) {}

  /**
   * controlla la compatibilità del browser e mostra avviso
   */
  async checkDeviceCompatibility(): Promise<void> {
    if (this.isIosChrome()) {
      await this.uiService.showAlert(
        'wrn.device_compatibility_title',
        'wrn.device_compatibility_ios_chrome_message'
      );
    }
  }

  /**
   * controlla che  il browser sia chrome su ios
   */
  isIosChrome(): boolean {
    return navigator.userAgent.match('CriOS') !== null;
  }

  /**
   * controlla se il device è un desktop
   */
  isDesktop(): boolean {
    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        window.navigator.userAgent
      );

    return !isMobile;
  }

  /**
   * controlla se l'app è in modalità nativa
   */
  isNative(): boolean {
    return Capacitor.isNativePlatform();
  }

  /**
   * restituisce le info del device
   */
  getDeviceInfo(): Promise<DeviceInfo> {
    if (!!this.deviceInfo) {
      return Promise.resolve({ ...this.deviceInfo });
    } else {
      return Device.getInfo()
        .then(info => (this.deviceInfo = info))
        .then(() => ({ ...this.deviceInfo }));
    }
  }

  /**
   * restituisce l'id univoco del device
   */
  getDeviceId(): Promise<string> {
    if (!!this.deviceId) {
      return Promise.resolve(this.deviceId);
    } else {
      return Device.getId()
        .then(res => (this.deviceId = res.identifier))
        .then(() => this.deviceId);
    }
  }
}
